import { HotkeyType, type IDelLayerData } from '@/framework';
import type { IExtraInfo, ILayerProps } from '@/version-types';

export enum LayerHotkeyType {
    /** 创建副本 */
    CLONE = 'layer-clone',
    /** 删除 */
    DELETE = HotkeyType.DELETE,
    /** 锁定 */
    LOCK = 'layer-lock',
    /** 置顶 */
    SORT_TOP = 'layer-sortTop',
    /** 置底 */
    SORT_BOTTOM = 'layer-sortBottom',
    /** 上移一层 */
    SORT_UP = 'layer-sortUp',
    /** 下移一层 */
    SORT_DOWN = 'layer-sortDown',
}

export enum HistoryType {
    /** 添加图层 */
    ADD = 'add',
    /** 删除 */
    DELETE = 'delete:o-group',
    /** 锁定 */
    LOCK = 'lock',
    /** 排序 */
    SORT = 'sort',
}

export type IHistoryLockData = {
    /** 图层 */
    item: ILayerProps;
};

/** 添加图层 */
export type IHistoryAddData = {
    /** 渲染数据，多人协作时，需要同步 */
    item: ILayerProps;
    /** 画布对应的额外信息 */
    extraInfo?: {
        oldExtraInfo: IExtraInfo;
        newExtraInfo: IExtraInfo;
    };
    /** 操作数据 */
    operate: {
        /** 旧的激活图层id */
        oldActiveId?: string;
        /** 是否激活新图层 */
        isActiveNewLayer: boolean;
    };
};

/** 排序图层 */
export type IHistorySortData = {
    /** 原始索引 */
    originIndex: number;
    /** 旧的排序列表 */
    oldSortList: { id: string; index: number }[];
    /** 新的排序列表 */
    newSortList: { id: string; index: number }[];
};

/** 删除图层 */
export type IHistoryDeleteData = {
    /** 历史数据 */
    historyData: IDelLayerData;
    /** 删除的原始图层 */
    originLayer: ILayerProps;
};
